<template>
  <v-autocomplete
    v-model="model"
    :items="items"
    :loading="isLoading"
    :search-input.sync="search"
    hide-details=""
    outlined
    item-text="name"
    item-value="phone"
    dense
    hide-no-data
    placeholder="Search by Name"
    prepend-inner-icon="mdi-magnify"
    return-object
    @change="openChat"
  >
    <template v-slot:item="data">
      <template>
        <v-list-item-content v-if="typeof data.item == 'object'">
          <v-list-item-title v-html="data.item.name"></v-list-item-title>
          <v-list-item-subtitle v-html="data.item.phone"></v-list-item-subtitle>
        </v-list-item-content>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import { chat_list } from "../../assets/js/firebase";
export default {
  data() {
    return {
      isLoading: false,
      model: null,
      search: null,
      items: []
    };
  },
  watch: {
    search() {
      this.initSearch();
    }
  },
  methods: {
    openChat() {
      const vm = this;
      let doc = {};
      Object.keys(vm.model).forEach(key => {
        doc[key] = vm.model[key];
      });
      vm.items = [];
      vm.$emit("click", doc);
    },
    async initSearch() {
      const vm = this;
      if (vm.search.length < 3) return;
      if (vm.isLoading) return;
      vm.isLoading = true;
      vm.items = [];
      let queryText = vm.search.toLowerCase();
      try {
        let snap = await chat_list
          .where("lower_name", ">=", queryText)
          .where("lower_name", "<=", queryText + "\uf8ff")
          .limit(5)
          .get();
        snap.docs.forEach(item => {
          let doc = item.data();
          doc.id = item.id;
          vm.items.push(doc);
        });
        console.log(vm.items);
        vm.isLoading = false;
      } catch (error) {
        console.log(error.message);
        vm.isLoading = false;
      }
    }
  },
  mounted() {}
};
</script>

<style></style>
